<template>
  <div class="footer">
    <div class="footer_box">
      <div class="footer_section" v-for="(section, index) in sections" :key="index">
        <div class="title bigger">{{ section.title }}</div>
        <ul class="footer_link">
          <li v-for="(item, idx) in section.items" :key="item.term + idx">
            <!-- router-link 情况 -->
            <router-link v-if="item.routeip && item.routeip.startsWith('/')" :to="item.routeip">
              {{ item.term }}
            </router-link>

            <!-- a 标签情况 -->
            <a v-else-if="item.routeip" :href="item.routeip" target="_blank">
              {{ item.term }}
            </a>

            <!-- 纯文本 -->
            <span v-else>
              {{ item.term }}
            </span>
          </li>

          <!-- Media 图标 -->
          <template v-if="section.title === 'Media'">
            <div class="footer_link_icon">
              <a v-for="(icon, i) in footerIcon" :key="i" :href="icon.link" target="_blank">
                <el-image :src="icon.url" fit="fill" class="icon">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </a>
            </div>
          </template>

          <!-- Logo 区域 -->
          <template v-if="section.title === ''">
            <li>
              <el-image src="https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/AiLifeLogonew.jpg" fit="fill" class="logo">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <!-- <div class="copyright">
      Copyright &copy; 2020 AiLife Diagnostics. All rights reserved
    </div> -->
  </div>
</template>

<script>
import picture from "@/utils/img";

export default {
  name: "footerBase",
  data() {
    return {
      footerIcon: picture.footerIcon(),
      sections: picture.footerList(),
    };
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background: #1a1e21;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  .footer_box {
    gap: 30px;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 30px 0;
    justify-content: center;
    box-sizing: border-box;
    // gap: 45px;
    // // padding: 2% 10%;
    // padding: 30px 16px;
    // max-width: 1200px;
    // box-sizing: border-box;
    // max-width: 1200px; /* 控制最大宽度，保持居中 */
    // @media (max-width: 1200px) {
    //   flex-wrap: wrap; /* 换行布局，变成多行堆叠 */
    //   overflow-x: visible; /* 不出现横向滚动条 */
    //   gap: 30px; /* 缩小间距 */
    //   padding: 2% 5%; /* 缩小内边距 */
    // }
  }

  .footer_section {
    flex: 0 0 auto;
    .title {
      color: #868788;
      font-size: 16px;
      margin-bottom: 10px;
      text-align: left;

      &.bigger {
        // font-size: 20px; /* Contact Us 标题大一点 */
        font-weight: 600;
      }
    }

    .footer_link {
      list-style: none;
      padding: 0;
      margin: 0;

      > li {
        margin-bottom: 5px;

        a {
          font-size: 16px;
          line-height: 30px;
          color: #ffffff;
          display: inline-block;
          width: 100%;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        span {
          color: #ffffff;
          font-size: 16px;
          line-height: 30px;
        }
      }

      .footer_link_icon {
        display: flex;
        margin-top: 10px;

        .icon {
          width: 25px;
          height: 25px;
        }

        a + a {
          margin-left: 10px;
        }
      }
    }

    .logo {
      width: 150px;
      height: 90px;
      // margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Footer/footer.vue